import React from "react";

import { FormattedMessage } from "react-intl";

import { Text } from "@/components/atoms/Text";
import InstantBook from "@/icons/__generated__/InstantBookFilled/InstantBookFilled20";
import Lightbulb from "@/icons/__generated__/Lightbulb/Lightbulb24";

interface InstantBookNoteProps {
  displayInstantBook: boolean;
  isMinimumDuration: boolean;
  showNewCancelCopy: boolean;
}

export const InstantBookNote: React.FC<InstantBookNoteProps> = ({
  displayInstantBook,
  isMinimumDuration,
  showNewCancelCopy,
}) => {
  return displayInstantBook ? (
    <div className="tw-mt-24 tw-text-gray-600">
      <div id="cancel-for-free-copy">
        <Text typeface="body-1-long" className="tw-mb-24">
          <FormattedMessage defaultMessage="You won't be charged yet." />
        </Text>
      </div>
      <div className="tw-flex tw-flex-col">
        <div className="tw-text-gray-900">
          <Text
            typeface="headline-1-m"
            className="tw-text-gray-900"
            prefix={<InstantBook />}
          >
            <FormattedMessage defaultMessage="Instant Book" />
          </Text>
        </div>
        <Text typeface="body-1-long" className="tw-ml-28">
          {showNewCancelCopy ? (
            <FormattedMessage defaultMessage="After payment, your booking will be instantly confirmed. Free cancellation within 24 hours of confirmation." />
          ) : (
            <FormattedMessage defaultMessage="After payment, your booking will be instantly confirmed. Free cancellation within 48 hours of confirmation." />
          )}
        </Text>
      </div>
    </div>
  ) : (
    <div className="tw-mt-24">
      <div className="tw-flex tw-flex-col tw-gap-12">
        <Text
          typeface="headline-1-m"
          prefix={<Lightbulb className="tw-text-yellow-600" />}
        >
          <FormattedMessage defaultMessage="Booking Request" />
        </Text>
        <Text typeface="body-1-long" className="tw-ml-32">
          {isMinimumDuration ? (
            <FormattedMessage defaultMessage="Bookings occurring within 24 hours require host approval." />
          ) : (
            <FormattedMessage defaultMessage="Booking durations shorter than the minimum hours require host approval. Extend your hours to Instant Book." />
          )}
        </Text>
      </div>
    </div>
  );
};
